import { Component } from '@angular/core';
import { ThemeService } from 'src/app/services/theme.service';

@Component({
  selector: 'app-theme-toggle',
  templateUrl: './theme-toggle.component.html',
  styleUrl: './theme-toggle.component.scss',
})
export class ThemeToggleComponent {
  constructor(private themeService: ThemeService) {}

  get darkModeEnabled() {
    return this.themeService.theme === 'accuzipDarkTheme';
  }

  handleThemeChange(ev: Event) {
    if (ev.target) {
      if ((ev.target as HTMLInputElement).checked) {
        this.themeService.setTheme('accuzipDarkTheme', true);
      } else {
        this.themeService.setTheme('accuzipLightTheme', true);
      }
    }
  }
}
